import { QuestionOutlined } from '@ant-design/icons';
import { Button, Flex, Tooltip, Typography } from 'antd';

const { Title } = Typography;

type PageLayoutProps = {
  children?: React.ReactNode;
  title?: string;
  actionItem?: React.ReactNode;
  help?: React.ReactNode;
};

export const PageLayout = ({
  children,
  title,
  actionItem,
  help,
}: PageLayoutProps) => {
  return (
    <Flex gap={16} vertical>
      <Flex align="center">
        <Flex
          style={{
            flex: '1 1 auto',
            minWidth: 0,
          }}
        >
          {title && <Title level={4}>{title}</Title>}
        </Flex>
        <Flex gap={16} align="center">
          {actionItem}
          {help && (
            <Tooltip title="Yardım">
              <Button
                type="primary"
                size="small"
                shape="circle"
                icon={<QuestionOutlined />}
              />
            </Tooltip>
          )}
        </Flex>
      </Flex>
      {children}
    </Flex>
  );
};
